import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const POB_POD = () => {
  const data = [
    ['Month', 'POB (in Thousands)', 'POD (in Thousands)'],
    ['January', 150, 140],
    ['February', 160, 150],
    ['March', 170, 160],
    ['April', 180, 170],
    ['May', 190, 180],
  ];

  const options = {
    title: 'POB vs POD Comparison',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Value (in Thousands)' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#4CAF50', '#FF9800'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default POB_POD;